



























































































import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator'

import { PAGE_TYPES } from '@/constants/ux-constants'
import type { PageType } from '@/constants/ux-constants'

import { OwnerNotificationPinningBuildingsGetResponse } from '@/dtos/buildings/owner-notifications/pinning/get'

import { BusinessDate } from '@/libs/business-date'
import { assertExhaustive } from '@/libs/exhaustive-helper'

import { buildingsModule } from '@/stores/buildings-store'

export class FormInputs {
  ownerNotificationId?: string | null = null
  closurePeriodSettingId?: string | null = null
  closureStartDate!: string
  closureEndDate!: string
  memo?: string
}

interface PageTypeSpecifications {
  pageTitle: string
  executeBtnLabel: string
  dialogMessage: string
}

class CreateSpecifications implements PageTypeSpecifications {
  readonly pageTitle = '休業期間を設定する'
  readonly executeBtnLabel = '設定する'
  readonly dialogMessage = '休業期間を設定します。よろしいですか？'
}

class UpdateSpecifications implements PageTypeSpecifications {
  readonly pageTitle = '休業期間を変更する'
  readonly executeBtnLabel = '変更する'
  readonly dialogMessage = '休業期間を変更します。よろしいですか？'
}

@Component({
  components: {
    SmBtn: () => import('@/components/atoms/SmBtn.vue'),
    SmText: () => import('@/components/atoms/SmText.vue'),

    SmDatePickers: () => import('@/components/molecules/SmDatePickers.vue'),
    SmTextarea: () => import('@/components/molecules/SmTextarea.vue'),

    SmDialogText: () => import('@/components/organisms/dialog/SmDialogText.vue'),
    SmModal: () => import('@/components/organisms/SmModal.vue'),
  }
})
export default class ClosurePeriodSettingCreateEditModal extends Vue {
  @Prop({ default: false })
  @Model('change', { required: true })
  private readonly isModalVisible!: boolean

  @Prop({ required: true, default: PAGE_TYPES.CREATE })
  private readonly pageType!: PageType

  @Prop({ default: '' })
  private readonly closurePeriodSettingId!: string

  @Prop({ default: '' })
  private readonly ownerNotificationId!: string

  @Prop({ default: '' })
  private readonly closureStartDate!: string

  @Prop({ default: '' })
  private readonly closureEndDate!: string

  @Prop({ default: undefined })
  private readonly memo?: string

  private get _isModalVisible(): boolean { return this.isModalVisible }
  private set _isModalVisible(newValue: boolean) {
    this.$emit('change', newValue)
  }

  private get isImmediate(): boolean {
    return this.pageType === PAGE_TYPES.EDIT
  }

  private localClosureStartDate = ''
  private localClosureEndDate = ''
  private localMemo: string | undefined = ''

  private businessDate = new BusinessDate()

  private get typeSpecs(): PageTypeSpecifications {
    switch (this.pageType) {
      case PAGE_TYPES.CREATE: return new CreateSpecifications()
      case PAGE_TYPES.EDIT: return new UpdateSpecifications()
      default: return assertExhaustive(this.pageType)
    }
  }

  mounted(): void {
    this.localClosureStartDate = this.closureStartDate
    this.localClosureEndDate = this.closureEndDate
    this.localMemo = this.memo
  }

  @Watch('closureStartDate')
  onClosureStartDateChanged(newVal: string): void {
    this.localClosureStartDate = newVal
    this.updateForm()
  }

  @Watch('closureEndDate')
  onClosureEndDateChanged(newVal: string): void {
    this.localClosureEndDate = newVal
    this.updateForm()
  }

  @Watch('memo')
  onMemoChanged(newVal: string | undefined): void {
    this.localMemo = newVal
    this.updateForm()
  }

  private updateForm(): void {
    const memoValue = this.localMemo && this.localMemo.trim() !== '' ? this.localMemo : undefined
    this.$emit('update', {
      closureStartDate: this.localClosureStartDate,
      closureEndDate: this.localClosureEndDate,
      memo: memoValue
    })
  }

  // 確認ダイアログ表示・非表示
  isPostDialogVisible = false
  onClickExecute(): void {
    this.isPostDialogVisible = false
    const closurePeriodSetting = new FormInputs()

    if (this.pageType === PAGE_TYPES.EDIT) {
      closurePeriodSetting.ownerNotificationId = this.ownerNotificationId
      closurePeriodSetting.closurePeriodSettingId = this.closurePeriodSettingId
    }
    const toDateClosureStartDate = new Date(this.localClosureStartDate)
    const toDateClosureEndDate = new Date(this.localClosureEndDate)
    closurePeriodSetting.closureStartDate = this.businessDate.toHyphenatedDateString(toDateClosureStartDate)
    closurePeriodSetting.closureEndDate = this.businessDate.toHyphenatedDateString(toDateClosureEndDate)
    closurePeriodSetting.memo = this.localMemo?.trim() !== '' ? this.localMemo : undefined
    this.$emit('post', closurePeriodSetting)
  }

  get ownerNotificationPinningBuildings(): OwnerNotificationPinningBuildingsGetResponse {
    return buildingsModule.ownerNotificationPinningBuildingsGet
  }

  get closureStartDateFormValidationRules(): string[] {
    const rules: string[] = []
    if (this.localClosureEndDate) {
      rules.push(`is_date_before:${this.localClosureEndDate},終了日以前の日付を選択してください`)
    }
    return rules
  }

  get closureEndDateFormValidationRules(): string[] {
    const rules: string[] = []
    if (this.localClosureStartDate) {
      rules.push(`is_date_after:${this.localClosureStartDate},開始日`)
    }
    return rules
  }
}

